import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedNumber, FormattedDate } from 'react-intl';
import { FormatMessage } from '../core';
import { orderConfirmationSummaryMessages } from './confirmationMessages';

export const OrderConfirmationSummary = ({ currency, orderNumber, orderTotalAmount, ccLastFour, ccStatementName }) => (
    <div className="order-confirmation-summary">
        <h2 className="order-confirmation-summary-heading">
            <FormattedMessage {...orderConfirmationSummaryMessages.heading} />
        </h2>
        <FormatMessage
            intlMessage={orderConfirmationSummaryMessages.description}
            className="order-confirmation-summary-description"
        />
        <FormatMessage
            intlMessage={orderConfirmationSummaryMessages.orderNumberLabel}
            className="order-confirmation-summary-order-num-label"
        />
        <div className="order-confirmation-summary-order-num">{orderNumber}</div>
        <div className="order-confirmation-summary-date">
            <FormattedDate value={new Date()} year="numeric" month="long" day="2-digit" />
        </div>
        <div className="order-confirmation-summary-total">
            <FormattedNumber style="currency" currency={currency || 'USD'} value={orderTotalAmount} />
        </div>
        <FormatMessage
            intlMessage={orderConfirmationSummaryMessages.ccLastFour}
            values={{ ccLastFour }}
            className="order-confirmation-summary-cc-num"
        />
        <FormatMessage
            intlMessage={orderConfirmationSummaryMessages.ccStatementName}
            values={{ ccStatementName }}
            className="order-confirmation-summary-cc-stmnt"
        />
    </div>
);

OrderConfirmationSummary.propTypes = {
    currency: PropTypes.string.isRequired,
    orderNumber: PropTypes.string.isRequired,
    orderTotalAmount: PropTypes.number.isRequired,
    ccLastFour: PropTypes.string.isRequired,
    ccStatementName: PropTypes.string.isRequired
};
